<!-- <div class="effective-dates">
    <div class="label">Effective Dates</div>
    <kendo-dropdownlist [data]="[]" class="dropdown" textField="description" valueField="id" [valuePrimitive]="true">
    </kendo-dropdownlist>
</div> -->
<div class="k-d-flex content k-p-6">
    <div class="col">
        <div class="key">
            Evaluation Site Only?
        </div>
        <div class="value">{{assessmentDetails?.evaluationSiteOnly}}</div>
    </div>
    <div class="col">
        <div class="key">
            Authorized Seats
        </div>
        <div class="value">{{assessmentDetails?.authorizationSeats}}</div>
    </div>
    <div class="col">
        <div class="key">
            Operating Seats
        </div>
        <div class="value">{{assessmentDetails?.operatingSeats}}</div>
    </div>
    <div class="col">
        <div class="key">
            Seats Available
        </div>
        <div class="value">{{assessmentDetails?.seatsAvailable}}</div>
    </div>

</div>
<kendo-card class=" k-mt-4 grid-width">
    <!-- <kendo-fileselect [showFileList]="false"   (select)="uploadFile($event)" 
        [multiple]="false">
    </kendo-fileselect> -->

    <kendo-grid [kendoGridBinding]="gridData" (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
        (selectionChange)="onAssessmentListSelectionChange($event)" (save)="saveHandler($event)"
        kendoGridSelectBy="contractSk" (remove)="removeHandler($event)" (add)="addHandler($event)"
        [(selectedKeys)]="assessmentListSelection" [selectable]="{ mode: 'multiple', drag: true }" [pageSize]="pageSize"
        [pageable]="true" [skip]="skip" (pageChange)="pageChange($event)">
        <ng-template kendoGridToolbarTemplate>

            <div class="flex">
                <h4 class="grid-header">Assessments Contract Award List</h4>
                <div class="d-flex">
                    <!-- <button kendoGridAddCommand themeColor="primary" fillMode="outline" [svgIcon]="plusIcon">Add New
                        Line Item</button> -->
                    <button kendoGridExcelCommand class="export-btn" (click)="this.excelexport.save()">Export to
                        Excel</button>
                </div>
            </div>
            <div class="inactivate-wrapper" *ngIf="assessmentListSelection?.length">
                <div class="selected-items">
                    Selected {{assessmentListSelection.length}} item(s)
                </div>
                <button kendoButton themeColor="primary" class="btn" fillMode="solid"
                    (click)="inactiveAssessmentsContract()">Inactivate</button>
            </div>

        </ng-template>

        <kendo-grid-checkbox-column [width]="25" [sticky]="true" [width]="52" headerClass="action-column"
            [class]="{ 'text-center': true }" [resizable]="false" [columnMenu]="false" [showSelectAll]="true"
            title="Checkbox column"></kendo-grid-checkbox-column>


        <kendo-grid-column field="evaluationType" title="Assessment Type" [width]="400">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="assessUsedDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="formGroup.get('evaluationType')">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem?.evaluationType,assessUsedDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="languageId" title="Language" [width]="210">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="languageDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="formGroup.get('languageId')">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.languageId,languageDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="settingId" title="Setting" [width]="210">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="settingsDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="formGroup.get('settingId')">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.settingId,settingsDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="serviceArea" title="Service Area" [width]="210">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="serviceAreaDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="formGroup.get('serviceArea')">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.serviceArea,serviceAreaDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="interpreterType" title="Interpreter Type" [width]="210">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-dropdownlist [data]="interpreterTypeDropdown" textField="description" valueField="id"
                    [valuePrimitive]="true" [formControl]="formGroup.get('interpreterType')">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dropdownData(dataItem.interpreterType,interpreterTypeDropdown)?.description }}
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="awardedRate" title="Awarded Rate" format="c" [width]="210" editor="numeric">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <kendo-numerictextbox [formControl]="$any(formGroup.get('awardedRate'))"
                    [format]="'c'"></kendo-numerictextbox>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="ownercontact" title="Owner (Main Contact)" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="formGroup.get('ownercontact')"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.ownercontact }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="owneremail" title="Owner Email Contact" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="formGroup.get('owneremail')"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.owneremail }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="ownerSe" title="Confirmed with SE" [width]="260">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="formGroup.get('ownerSe')"
                    [maxlength]="64"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.ownerSe }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="tempContractNumber" title="Temp Contract Number" [width]="210">
            <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
                <kendo-textbox rounded="large" [formControl]="formGroup.get('tempContractNumber')"
                    [maxlength]="10"></kendo-textbox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem?.tempContractNumber }}
            </ng-template>
        </kendo-grid-column>

        <!-- <kendo-grid-command-column title="Actions" [sticky]="true" [width]="110">
            <ng-template kendoGridCellTemplate let-isNew="isNew">

                <button kendoGridEditCommand [svgIcon]="penIcons" themeColor="secondary" class="edit-btn"
                    fillMode="flat" aria-label="Edit row"></button>
               <button kendoGridRemoveCommand [svgIcon]="xMarkIcons"></button> 
                <button kendoGridSaveCommand themeColor="primary" [svgIcon]="checkIcon" [disabled]="formGroup?.invalid">
                     {{ isNew ? "Add" : "Update" }} 
                </button>
                <button kendoGridCancelCommand class="cancel-btn" [svgIcon]="xMarkIcons">
                  {{ isNew ? "Discard changes" : "Cancel" }} 
                </button>
            </ng-template>
        </kendo-grid-command-column> -->
    </kendo-grid>
</kendo-card>




<app-in-active-assessments-dialog *ngIf="inactiveAssessmentContract$ | async"
    (closeDialog)="closeInactiveAssessmentContractDialog($event)"
    [assessmentListSelection]="assessmentListSelection"></app-in-active-assessments-dialog>


<kendo-excelexport [data]="assessmentContractExportData" fileName="AssessmentContract.xlsx" #excelexport>
    <kendo-excelexport-column field="evaluationType" title="Evaluation Type">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="languageId" title="Language">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="settingId" title="Setting">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="serviceArea" title="Service Area">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="interpreterType" title="Interpreter Type">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="awardedRate" title="Awarded Rate">
    </kendo-excelexport-column>
</kendo-excelexport>